import { Box, Heading, Text } from "@chakra-ui/react";

export interface ProductLinksProps {
  subcategory: string;
}

export const ProductLinks = (props: ProductLinksProps) => {
  const { subcategory } = props;

  return subcategory.includes("Radon") ? (
    <>
      <Heading
        as="h2"
        id="quick-facts"
        fontWeight="bold"
        size="3xl"
        mb={{ base: 6, lg: 10 }}
      >
        Highly Rated Products
      </Heading>
      <Text
        mb={3}
        textAlign={{
          base: "center",
          lg: "left",
        }}
      >
        These highly-rated radon test kits and monitors may help you learn if
        indoor radon is building up in your home:
      </Text>
      <Text
        mb={10}
        textAlign={{
          base: "center",
          lg: "left",
        }}
      >
        These products are not endorsed by AreaHub and AreaHub will not be
        liable for your use of the product if you purchase it. If you buy
        something through these links, AreaHub will be compensated and/or
        receive a commission.
      </Text>
      <Box h="300px" mx="auto" maxW="1050px">
        <Box
          as="iframe"
          src="https://areahub-pics.s3.amazonaws.com/static/radon-affiliate-grid.html"
          width="100%"
          height="100%"
        />
      </Box>
    </>
  ) : (
    <>
      <Heading
        as="h2"
        id="quick-facts"
        fontWeight="bold"
        size="3xl"
        mb={{ base: 6, lg: 10 }}
      >
        Highly Rated Products
      </Heading>
      <Text
        mb={3}
        textAlign={{
          base: "center",
          lg: "left",
        }}
      >
        These highly-rated air purifiers and monitors may help measure and
        improve your indoor air quality:
      </Text>
      <Text
        mb={10}
        textAlign={{
          base: "center",
          lg: "left",
        }}
      >
        These products are not endorsed by AreaHub and AreaHub will not be
        liable for your use of the product if you purchase it. If you buy
        something through these links, AreaHub will be compensated and/or
        receive a commission.
      </Text>
      <Box maxW="1050px" h="540px" mx="auto" overflow="hidden">
        <Box
          as="iframe"
          src="https://areahub-pics.s3.amazonaws.com/static/air-quality-affiliate-grid.html"
          width="100%"
          height="100%"
        />
      </Box>
    </>
  );
};

export default ProductLinks;
